import CurriculumPage from "./CurriculumPage";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { coursesApi } from "../../../utils";
import { throwApiError } from "../../lms-shared/store/error-handling-actions";


const CurriculumPageWarrper = () => {
    const texts = useSelector(state => state.translate.texts);
    const [data, setData] = useState({})
    const { courseId } = useParams()
    const dispatch = useDispatch();
    const componentMounted = useRef(true);
    const location = useLocation();
    const navigateToUrl = location.state && location.state.navigateToUrl;

    useEffect(() => {
        coursesApi.coursesFilterIdPost(courseId, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.coursesFilterError, error: error, statusCode: response?.statusCode, message: "coursesFilterRangePost " + error.message, level: 2, component: "CoursesPage", line: 29 }))
            } else {
                if (componentMounted.current) {
                    if (resdata.additionalData) {
                        const parse = JSON.parse(resdata.additionalData)
                        resdata.additionalData = parse;
                        resdata.pageBackgroundImage = `${resdata.baseUrl}/${parse?.PageBackgroundImage}`
                    }
                    setData({ ...resdata })
                }
            }
        })
    }, [courseId])

    useEffect(() => {
        return () => {
            componentMounted.current = false;
        }
    }, [])

    return (
        <div>
            <CurriculumPage  navigateToUrl={navigateToUrl} data={data}>  </CurriculumPage>
        </div>
    )

}
export default CurriculumPageWarrper